import ApiService from '@/core/services/api.service';

export async function validateLineVouchers({
  voucherCodes = [],
  existingVouchers = [],
  productId,
  productPrice,
  quantity = 1,
  storeId,
  customerId,
  billTotalAmount,
  stackedDiscountProgramIds,
}) {
  try {
    const payload = {
      voucherCodes,
      existingVouchers,
      productId,
      productPrice,
      quantity,
      storeId,
      customerId,
      billTotalAmount,
    };
    if (Array.isArray(stackedDiscountProgramIds) && stackedDiscountProgramIds.length > 0) {
      payload.stackedDiscountProgramIds = stackedDiscountProgramIds.map((id) => Number(id));
    }

    const response = await ApiService.post('v2/vouchers/validate-line', payload);

    if (response.data.status === 200) {
      return {
        status: 1,
        message: response.data.message,
        data: response.data.data,
      };
    }
    return {
      status: 0,
      message: response.data.message || 'Có lỗi xảy ra khi kiểm tra voucher',
    };
  } catch (error) {
    console.error('Validate-line error:', error);
    if (error.response && error.response.data) {
      return {
        status: 0,
        message: error.response.data.message || 'Mã voucher không hợp lệ',
      };
    }
    return {
      status: 0,
      message: 'Có lỗi xảy ra khi kiểm tra mã voucher',
    };
  }
}
